import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/90",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive/10 text-destructive hover:bg-destructive/15",
        outline: "border-border text-foreground",
        /* Premium pastel badges per design system */
        gold: "border-transparent bg-[hsl(var(--brand-gold)/0.15)] text-[hsl(var(--brand-navy))] hover:bg-[hsl(var(--brand-gold)/0.22)]",
        verified: "border-transparent bg-[hsl(var(--brand-green)/0.12)] text-[hsl(var(--brand-green))] hover:bg-[hsl(var(--brand-green)/0.18)]",
        navy: "border-transparent bg-[hsl(var(--brand-navy)/0.08)] text-[hsl(var(--brand-navy))] hover:bg-[hsl(var(--brand-navy)/0.12)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
